import getPatientDob1 from 'utils/print/getPatientDob1';
import getPatientDob2 from 'utils/print/getPatientDob2';
import getPatientDob3 from 'utils/print/getPatientDob3';

const getPatientFullDob = ({ value, ...otherProps }) => {
  if (value !== null && value !== undefined) {
    return value;
  }

  return `${getPatientDob1(otherProps)}/${getPatientDob2(otherProps)}/${getPatientDob3(otherProps)}`;
};

export default getPatientFullDob;



// WEBPACK FOOTER //
// ./src/utils/print/getPatientFullDob.js